import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page44() {
  useEffect(() => {
    document.title = "Маяк — Страница 43"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page42" />
        <ForwardLink href="/page44" />
      </div>

      <p style={{ textAlign: "right" }}>43.</p>
      <p>Пауза.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Что?
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Свет?
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Я хранитель этой станции,<br/>
        парень.
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Я... Я не...
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК (ПРОДОЛЖЕНИЕ)<br/>
        На какой-нибудь другой станции ты сможешь присматривать<br/>
        за светом.
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        В руководстве говорится--
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Мой журнал – единственная книга на этом<br/>
        камне--
      </p>
      <p style={{ display: "flex" }}>
        <div>
          <div style={{ textAlign: "center" }}>МОЛОДОЙ</div>
          Я имею в виду, я викки, как Вы<br/>
          говорите, но я ни одного фитиля<br/>
          не подрезал--
        </div>
        <div style={{ marginLeft: "auto" }}>
          <div style={{ textAlign: "center" }}>СТАРИК (ПРОДОЛЖЕНИЕ)</div>
          Это Евангелие!
        </div>
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК (ПРОДОЛЖЕНИЕ)<br/>
        Я хранитель маяка, парень, и<br/>
        не дам никому к нему прикоснуться--
      </p>
      <p style={{ display: "flex"}}>
        <div>
          <div style={{ textAlign: "center" }}>МОЛОДОЙ</div>
          Я не -- в книге говорится, мы<br/>
          должны меняться--
        </div>
        <div style={{ marginLeft: "auto" }}>
          <div style={{ textAlign: "center" }}>СТАРИК (ПРОДОЛЖЕНИЕ)</div>
          Не беспокойся<br/>
          о маяке! Он мой, парень!
        </div>
      </p>
      <p>СТАРИК наливает себе еще одну.</p>
      <p>МОЛОДОЙ смеется. Напряжение уходит.</p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Будь по-вашему... э-э... Скажите, я<br/>
        никогда... я не знаю Вашего имени.
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Уэйк.
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Как Вас назвали при крещении?
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Томас.
      </p>
      <p style={{ textAlign: "right" }}>43.</p>
      
      <Navigation />
      
      <div className="NavigationLink-wrapper">
        <BackLink href="/page42" />
        <ForwardLink href="/page44" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1710314712/the-lighthouse-script/e9bbqbopp2ukknkjqbbb.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page44;
